<template>
  <!-- editable @edit="handleTabsEdit" -->
  <el-tabs v-model="tabsValue" type="card" closable @tab-remove="removeTab" @tab-click="tabClick">
    <el-tab-pane
      :key="item.id"
      v-for="(item, index) in tabsData"
      :label="item.title"
      :name="item.name"
    >
      <!-- <router-view></router-view> -->
      <!-- <keep-alive> -->
      <component v-bind:is="item.component" :templateQuery="item.templateQuery"></component>
      <!-- </keep-alive> -->
      <slot></slot>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import TaskDelayMain from '@/views/task/taskDelay/TaskDelayMain.vue';
import TaskRecord from '@/views/task/Record/index';
import taskList from './taskList.vue';
export default {
  components:{
    TaskDelayMain,
    taskList,
    TaskRecord
  },
  // props:{
  //   tabsData:{
  //     type:Array,
  //     default:[]
  //   }
  // },
  data() {
    return {
      tabsValue: "1",
      tabsData: [
        // {
        //   title: "所有任务",
        //   name: "1",
        //   id: "1",
        //   content: ""
        // }
      ],
      tabIndex: 1,
    };
  },
  computed: {
    currentTabComponent: function () {
      return 'tab-' + this.currentTab.toLowerCase()
    }
  },
  methods: {
    // handleTabsEdit(targetName, action) {
    //   if (action === "add") {
    //     let newTabName = ++this.tabIndex + "";
    //     this.tabsData.push({
    //       title: "New Tab",
    //       name: newTabName,
    //       content: "New Tab content"
    //     });
    //     this.tabsValue = newTabName;
    //   }
    //   if (action === "remove") {
    //     let tabs = this.tabsData;
    //     let activeName = this.tabsValue;
    //     if (activeName === targetName) {
    //       tabs.forEach((tab, index) => {
    //         if (tab.name === targetName) {
    //           let nextTab = tabs[index + 1] || tabs[index - 1];
    //           if (nextTab) {
    //             activeName = nextTab.name;
    //           }
    //         }
    //       });
    //     }

    //     this.tabsValue = activeName;
    //     this.tabsData = tabs.filter(tab => tab.name !== targetName);
    //   }
    // },
    tabClick(tab){
      // console.log('获取值',tab)
      // this.$store.state.task.searchCondition = [];
      // console.log(tab.componentName)
      // if(tab.componentName=='workingTable'){

      //   this.$store.state.task.searchCondition = [];
      // }else{
        // console.log('模板:',tab.templateQuery);
        // let content = JSON.parse(tab.templateQuery.CONTENT);
        // this.$store.state.task.searchCondition = content.queryTitle;
      // }
    },
    removeTab(targetName) {
      let tabs = this.tabsData;
      let activeName = this.tabsValue;
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.name === targetName) {
            let nextTab = tabs[index + 1] || tabs[index - 1];
            if (nextTab) {
              activeName = nextTab.name;
            }
          }
        });
      }
      this.tabsValue = activeName;
      this.tabsData = tabs.filter(tab => tab.name !== targetName);
    },
    addTab(title, id,componentName) {
      let containTab = this.tabsData.filter(item => item.name === id);
      if (containTab.length === 0) {
        this.tabsData.push({
          title: title,
          name: id,
          id: id,
          content: "",
          component:componentName,
        });
        this.tabsValue = id;
      } else {
        this.tabsValue = id;
      }
    },
    editAddTab(title, id,componentName,templateQuery) {
      let containTab = this.tabsData.filter(item => item.name === id);
      if (containTab.length === 0) {
        this.tabsData.push({
          title: title,
          name: id,
          id: id,
          content: "",
          component:componentName,
          templateQuery:templateQuery
        });
        this.tabsValue = id;
      } else {
        this.tabsData.forEach(item=>{
          if(item.name===id){
            item.title=title;
            item.templateQuery=templateQuery;
          }
        })
        this.tabsValue = id;
      }
    }
  }
};
</script>

<style scoped>
</style>
